var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Button from "../Button/Button";
import FooterLinks from "../FooterLinks";
import Heading from "../Heading";
import Markdown from "../Markdown";
import Text from "../Text";
import { Col, Row } from "../grid";
import useModal from "../../hooks/useModal";
import { darken } from 'polished';
import React, { useState } from 'react';
import { display } from 'styled-system';
import { styled, css, mq } from "../../utils";
import CookiesModal from "./CookiesModal";
var StyledCol = styled(Col)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  overflow-y: auto;\n"], ["\n  position: relative;\n  overflow-y: auto;\n"])));
var StyledMarkdown = styled(Markdown)(function (_a) {
    var _b = _a.theme, font = _b.font, colors = _b.colors, marginBottom = _a.marginBottom;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    p {\n      margin-bottom: ", ";\n      font-size: ", ";\n    }\n    a {\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    }\n  "], ["\n    p {\n      margin-bottom: ", ";\n      font-size: ", ";\n    }\n    a {\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    }\n  "])), marginBottom, font.size.normal, colors.midnight, darken(0.1, colors.midnight));
});
var StyledButton = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-transform: none;\n  padding: 0;\n"], ["\n  text-transform: none;\n  padding: 0;\n"])));
var Wrapper = styled(Row)(function (_a) {
    var _b = _a.theme, colors = _b.colors, space = _b.space;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    z-index: 8;\n    background: ", ";\n    position: fixed;\n    bottom: 0;\n    ", ";\n  "], ["\n    z-index: 8;\n    background: ", ";\n    position: fixed;\n    bottom: 0;\n    ", ";\n  "])), colors.midnight, mq({ padding: [space[2] + "px 8px", null, space[3]] }));
});
var StyledCard = styled(Row)(function (_a) {
    var colors = _a.theme.colors;
    return ({
        background: colors.white,
        borderRadius: 24,
    });
});
var SecondaryButton = styled(Button)(function (_a) {
    var _b = _a.theme, colors = _b.colors, font = _b.font;
    return ({
        '&&': {
            fontSize: font.size.large,
            fontWeight: font.weight.bold,
            border: "solid 3px " + colors.midnight,
            borderRadius: 34,
            height: 74,
            '&:hover': {
                background: colors.midnight,
                color: colors.white,
                borderColor: colors.midnight,
            },
        },
    });
}, display);
var PrimaryButton = styled(Button)(function (_a) {
    var _b = _a.theme, font = _b.font, colors = _b.colors;
    return [
        {
            '&&': {
                background: 'linear-gradient(90deg, #c8d9f0 -99%, #153255 94%)',
                fontSize: font.size.large,
                border: 'unset',
                fontWeight: font.weight.bold,
                borderRadius: 35,
                height: 74,
                '&:hover': {
                    background: 'linear-gradient(90deg, #c3cbd9, #a5aebf)',
                    color: colors.backgroundSecondary,
                },
            },
        },
    ];
});
var SettingsText = styled(Text)(function (_a) {
    var _b = _a.theme, colors = _b.colors, font = _b.font;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    span {\n      text-decoration: underline;\n      color: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n      padding: 0 5px;\n      cursor: pointer;\n      &:hover {\n        color: ", ";\n      }\n    }\n  "], ["\n    span {\n      text-decoration: underline;\n      color: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n      padding: 0 5px;\n      cursor: pointer;\n      &:hover {\n        color: ", ";\n      }\n    }\n  "])), colors.midnight, font.size.normal, font.weight.semiBold, darken(0.1, colors.midnight));
});
var CookiesConsent = function (_a) {
    var title = _a.title, shortDescription = _a.shortDescription, extraDescription = _a.extraDescription, settingsText = _a.settingsText, settingsButton = _a.settingsButton, settingsTextEnd = _a.settingsTextEnd, essentialCookiesTitle = _a.essentialCookiesTitle, props = __rest(_a, ["title", "shortDescription", "extraDescription", "settingsText", "settingsButton", "settingsTextEnd", "essentialCookiesTitle"]);
    var _b = useState(false), showMoreInfo = _b[0], setShowMoreInfo = _b[1];
    var modalHook = useModal();
    var handleSubmitCookies = function (cookieValue) {
        props.onSubmit(cookieValue);
        modalHook.hideModal();
    };
    return (React.createElement(Wrapper, { width: 1, height: ['80%', 'auto'] },
        React.createElement(StyledCard, { flexDirection: "column", p: 4 },
            React.createElement(StyledCol, { width: 1, p: 0 },
                React.createElement(Heading.Heading3, { mb: 1, fontWeight: "extraBold" }, title),
                React.createElement(StyledMarkdown, { marginBottom: showMoreInfo ? '1rem' : '0', children: shortDescription }),
                settingsText && (React.createElement(SettingsText, { m: 0, fontSize: 1 },
                    settingsText,
                    React.createElement("span", { onClick: modalHook.showModal }, settingsButton),
                    settingsTextEnd)),
                showMoreInfo && React.createElement(StyledMarkdown, { children: extraDescription }),
                extraDescription && (React.createElement(StyledButton, { ghost: true, onClick: function () { return setShowMoreInfo(function (prevState) { return !prevState; }); } }, !showMoreInfo ? props.moreInfoLabel : props.lessInfoLabel)),
                React.createElement(CookiesModal, __assign({ modalHook: modalHook }, props))),
            React.createElement(Row, { flexDirection: ['column-reverse', null, 'row'], flexWrap: ['wrap', null, 'nowrap'], mt: 4 },
                React.createElement(Col, { display: "flex", justifyContent: "center", px: 0, width: [1, null, 3 / 10] },
                    React.createElement(SecondaryButton, { block: true, outline: true, onClick: function () { return handleSubmitCookies(false); }, display: "block" }, essentialCookiesTitle)),
                React.createElement(Col, { display: "flex", p: 0, justifyContent: "center", alignItems: "center", width: [1, null, 3 / 10], ml: [0, null, 4], mb: [3, null, 0] },
                    React.createElement(PrimaryButton, { block: true, variant: "primary", onClick: function () { return handleSubmitCookies(true); } }, props.submitAllLabel))),
            props.links && (React.createElement(Col, { display: "flex", justifyContent: ['center', null, 'flex-start'], mt: 3 },
                React.createElement(FooterLinks, { links: props.links }))))));
};
export default CookiesConsent;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=CookiesConsent.js.map